import React from 'react';
import PropTypes from 'prop-types';
import { StyledButtonText } from 'components/Modal/StyledComponents';
import {
  StyledButton,
  StyledDescription,
  StyledTitle,
} from 'components/Modal/NotificationModal/StyledComponents';
import { ModalLayout } from 'components/Modal/NotificationModal/LayoutComponents';

export const NotificationModal = ({ title, description, buttons }) => (
  <ModalLayout>
    <ModalLayout.Content>
      <StyledTitle>{title}</StyledTitle>
      {description && (
        <StyledDescription>
          {description.split('/n').map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
        </StyledDescription>
      )}
    </ModalLayout.Content>

    <ModalLayout.Navigation>
      {buttons.map((btn, idx) => {
        return (
          <StyledButton key={idx} onEnter={btn.handler}>
            <StyledButtonText>{btn.text}</StyledButtonText>
          </StyledButton>
        );
      })}
    </ModalLayout.Navigation>
  </ModalLayout>
);

NotificationModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onModalBack: PropTypes.func,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      handler: PropTypes.func,
    }),
  ),
};
